export const SETTINGS = {
    BASE_URL: process.env.REACT_APP_BASE_URL, // Ensure this matches the variable name in your .env file
    BASE_API: process.env.REACT_API_BASE_URL, // Ensure this matches the variable name in your .env file
    APP_VERSION: process.env.APP_VERSION,
};
